import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

interface Active { id: string; company_id: string; expires_at: string; can_write: boolean }

/**
 * Impersonation must never be mistakable for a normal session. This sits above
 * everything, names the company, counts down, and offers one way out.
 */
export function ImpersonationBanner({ companyName }: { companyName: string }) {
  const [active, setActive] = useState<Active | null>(null);
  const [left, setLeft] = useState("");

  useEffect(() => {
    void supabase.rpc("active_impersonation").then(({ data }) => {
      const row = (Array.isArray(data) ? data[0] : data) as Active | undefined;
      setActive(row ?? null);
    });
  }, []);

  useEffect(() => {
    if (!active) return;
    const tick = () => {
      const ms = new Date(active.expires_at).getTime() - Date.now();
      if (ms <= 0) { window.location.reload(); return; }
      const m = Math.floor(ms / 60000);
      setLeft(`${m}m ${Math.floor((ms % 60000) / 1000)}s`);
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [active]);

  if (!active) return null;

  return (
    <div className="impersonating" role="status">
      <span>
        <b>Support session</b> — you are viewing {companyName} as Hauzisha staff
        {active.can_write ? " with write access" : " (read only)"}. Ends in {left}.
      </span>
      <button
        onClick={async () => {
          await supabase.rpc("end_impersonation", { p_id: active.id });
          window.location.reload();
        }}
      >
        End now
      </button>
    </div>
  );
}
